import { css } from 'styled-components';

const sizes = {
  desktop: 1100, // ∞ - 1100 = desktop
  mobile: 400, // 1100 - 400 = tablet ?
};

// Iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${sizes[label] / 16}em) {
      ${css(...args)};
    }
  `;
  return acc;
}, {});
